module.exports = __webpack_public_path__ + "img/漾肤.c5da358.png";